"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListItemText = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledListItemText = (0, styles_1.styled)(material_1.ListItemText, {
    shouldForwardProp: prop => prop !== "long",
})(({ long, theme }) => ({
    flex: long ? 2 : 1,
    paddingRight: theme.spacing(1),
    wordWrap: "break-word",
}));
//# sourceMappingURL=index.js.map